module.exports = __webpack_public_path__ + "static/implant03-1631e3bc2e8b299621706c6c33467689.jpg";